<template>
  <el-form ref="form" :model="dataInfo"  :rules="rules" :hide-required-asterisk="true" label-position="top">

    <div class="white-box" >
      <div class="label">项目可行性分析报告</div>
      <el-form-item label="" prop="team">
        <editor v-model="dataInfo.team" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="上传分析报告【选填】" prop="fxbgFileIdList">
        <custom-upload v-model="dataInfo.fxbgFileIdList" :disabled="disabled"/>
      </el-form-item>
    </div>

  </el-form>
</template>

<script>
import Editor from '@/components/editor'
import CustomUpload from '@/components/custom-upload'

export default {
  components: {
    Editor,
    CustomUpload,
  },
  props: {
    dataInfo: {
      type: Object,
      default: ()=>{
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var checkFileList = (rule, value, callback, paramName) => {
      if (this.dataInfo[paramName].length == 0) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    return {
      rules: {
        team:[{ required: true, message:'请填写项目可行性分析报告', trigger: 'change' }],
      },
    }
  },
  watch: {
  },
  computed: {
  },
  mounted() {
    let team = '<p><span style="color: rgb(165, 165, 165); font-size: 16px;">1、项目创业团队(姓名、性别、年龄、籍贯，学历/学位、毕业院校，行业从业年限，主要经历和经营业绩，拟注册公司法人，项目实施后创业团队各成员工作分工和职务情况(包括全职/兼职))</span></p><p><span style="color: rgb(0, 0, 0); font-size: 16px;"><br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;">2、项目产品/服务(产品/服务介绍，产品技术及水平，产品的新颖性、先进性和独特性，产品的竞争优势，知识产权情况)</span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;"></span></p><p><span style="color: rgb(0, 0, 0); font-size: 16px;"><br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;">3、研究与开发(已有的技术成果，研发队伍技术水平、竞争力及对外合作情况，已经投入的研发经费及今后投入计划，对研发人员的激励机制)</span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;"></span></p><p><span style="color: rgb(0, 0, 0); font-size: 16px;"><br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;">4、产业化程度(阶段性成果描述，何时产业化，原始材料及机器设备情况，中试是否完成)</span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;"><br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;">5、生产研发说明 (工艺流程描述、生产研发等空间布局说明)<br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;"></span></p><p><span style="color: rgb(0, 0, 0); font-size: 16px;"><br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;">6、市场(行业历史与前景，市场规模及增长趋势，是否有订单，行业竞争对手及本公司竞争优势，未来 3 年市场销售预测)<br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;"></span></p><p><span style="color: rgb(0, 0, 0); font-size: 16px;"><br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;">7、融资说明(目前项目已投资金，无形资产自评，资金需求量、用途、使用计划，拟出让股份，投资者权利，退出方式)<br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;"></span></p><p><span style="color: rgb(0, 0, 0); font-size: 16px;"><br/></span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;">8、财务预测 (未来3 至5 年的销售收入、利润、资产回报率等)</span></p><p><span style="color: rgb(165, 165, 165); font-size: 16px;"></span></p><p><span style="color: rgb(0, 0, 0); font-size: 16px;"><br/></span></p>'
    this.$set(this.dataInfo, 'team', team)
  },
  methods: {
    validate(callback){
      this.$refs['form'].validate((valid, object) => {
        callback && callback(valid, object)
      });
    },
  },
}
</script>

<style lang='less' scoped>
  @import url(./index.less);
</style>
